import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { RoutesPath } from "../constants";

const UnAuthenticatedRoutes = () => {
  const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";

  return !isAuthenticated ? (
    <Outlet />
  ) : (
    <Navigate to={RoutesPath.DASHBOARD} replace />
  );
};

export default UnAuthenticatedRoutes;